import React from 'react';
import { useHistory } from 'react-router-dom';
import { WeezHeader, Card, Modal, Button } from '@weezevent/nacre';
import { ImportProcess } from '../../../nacre/importController';
import { useTranslation } from 'react-i18next';
import { useForm } from '@weezevent/weezjs-core';
import UploadRequestPartnerConfigModel from '../../../models/UploadRequestPartnerConfig';

import { FileStep, AnalysisStep } from '../../attendees/import/steps';

export default function PartnerImport({ organization }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [newFileModal, setNewFileModal] = React.useState(false);
    const [uploadSuccess, setUploadSuccess] = React.useState(false);

    const [form, setForm, setFormObject] = useForm(
        {
            file: [],
            importRequest: null,
            requestDatas: {}
        },
        []
    );

    return (
        <>
            <WeezHeader title={t('ticket.partners.imports.title')} backLink={{ onClick: () => history.push(`/ticket/O${organization.id}/partners`) }} />
            {newFileModal && (
                <Modal
                    title={t('ticket.attendees.imports.modal.title')}
                    open={newFileModal}
                    onClose={() => setNewFileModal(false)}
                    submitButton={
                        <Button color="red" labelPostion="left" onClick={() => window.location.reload()}>
                            {t('ticket.common.cta.confirm')}
                        </Button>
                    }
                    cancelButton={<Button onClick={() => setNewFileModal(false)}>{t(`ticket.common.action.back`)}</Button>}
                >
                    {t('ticket.attendees.imports.modal.body')}
                </Modal>
            )}
            <Card.FormManager labelPreviousStepMobile={t('ticket.common.back_step')} labelStepMobile={t(['ticket.common.step'])} withStepsMobile>
                <Card.FormStep
                    editLabel={t('ticket.common.action.edit')}
                    title={`1 - ${t('ticket.partners.imports.steps.file.title')}`}
                    subtitle={t('ticket.partners.imports.steps.file.subtitle')}
                    summary={`${t('ticket.attendees.imports.steps.file.summary')}: ${form.file?.path}`}
                >
                    <FileStep
                        typeKeys={['partners', 'attendees']}
                        uploadModel={UploadRequestPartnerConfigModel}
                        fileName={'template_import_partners.xlsx'}
                        onDone={onCardDone => {
                            onCardDone();
                        }}
                        setUploadSuccess={setUploadSuccess}
                        blockContinue={!uploadSuccess}
                        organization={organization}
                        form={form}
                        setFormObject={setFormObject}
                        setForm={setForm}
                        onUpload={resp => setForm('requestDatas', new ImportProcess(resp))}
                    />
                </Card.FormStep>
                <Card.FormStep
                    editLabel={t('ticket.common.action.edit')}
                    title={`2 - ${t('ticket.partners.imports.steps.analysis.title')}`}
                    subtitle={t('ticket.partners.imports.steps.analysis.subtitle')}
                >
                    <AnalysisStep
                        triggerAnalysis
                        typeKeys={['partners', 'attendees']}
                        redirectUrl={`/ticket/O${organization.id}/partners`}
                        organization={organization}
                        form={form}
                        setForm={setForm}
                        setFormObject={setFormObject}
                        openModal={() => setNewFileModal(true)}
                        onDone={(requestDatas, onCardDone) => {
                            setForm('requestDatas', requestDatas);
                            onCardDone();
                        }}
                    />
                </Card.FormStep>
            </Card.FormManager>
        </>
    );
}
